const normalizeRole = (role) => {
  const resolved = String(role || "").trim().toLowerCase();
  if (resolved === "owner") return "owner";
  if (["admin", "manager", "viewer"].includes(resolved)) return resolved;
  return "viewer";
};

export const isAdmin = (role) => {
  const resolved = normalizeRole(role);
  return resolved === "admin" || resolved === "owner";
};

export const isViewer = (role) => normalizeRole(role) === "viewer";

export const isManager = (role) => normalizeRole(role) === "manager";